<app-header></app-header>
<div class="container-fluid">
  @if (data) {
    <div>
      <h2 style="padding-top: 30px;">{{data['id']}}</h2>
      <hr>
      <dl fxLayout="column">
        <!-- ontology_term -->
        @if (data.hasOwnProperty('term')) {
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Ontology Term:</dt>
            <dd fxFlex="75">{{data['term']}}</dd>
          </div>
        }
        <!-- type -->
        @if (data.hasOwnProperty('type')) {
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Ontology Type:</dt>
            <dd fxFlex="75">{{data['type']}}</dd>
          </div>
        }
        <!-- status -->
        @if (data.hasOwnProperty('status_activity')) {
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Status Activity:</dt>
            <dt fxFlex="50">
              <mat-accordion>
                <mat-expansion-panel style="margin-bottom: 20px;">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <button mat-icon-button disabled>
                        <mat-icon>thumb_up</mat-icon>
                      </button>
                      <span>{{data['upvotes_count']}}</span>
                      <button mat-icon-button disabled>
                        <mat-icon>thumb_down</mat-icon>
                      </button>
                      <span>{{data['downvotes_count']}}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @for (action of data['status_activity']; track action) {
                    <div style="margin-bottom: 10px;">
                      <div style="font-size: 14px; color: #4d759a;">
                        {{action.timestamp.replace('T', ' ').replace('+', ' +')}}
                      </div>
                      <div>{{generateStatusMsg(action)}}</div>
                      @if (action.comments) {
                        <div>
                          {{action.user}} provided the following feedback: <span class="userComments">{{action.comments}}</span>
                        </div>
                      }
                    </div>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            </dt>
          </div>
        }
        <!-- project -->
        @if (data.hasOwnProperty('projects') && data['projects'] && data['projects'].length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Project:</dt>
            <dd fxFlex="75">{{data['projects']}}</dd>
          </div>
        }
        <!-- species -->
        @if (data.hasOwnProperty('species') && data.species && data.species.length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Species:</dt>
            <dd fxFlex="75">{{data['species']}}</dd>
          </div>
        }
        <!-- tags -->
        @if (data.hasOwnProperty('tags') && data['tags'] && data['tags'].length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Tags:</dt>
            <dd fxFlex="75">{{data['tags']}}</dd>
          </div>
        }
        <!-- iri -->
        @if (data.hasOwnProperty('iri') && data['iri']) {
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Ontology IRI:</dt>
            <dd fxFlex="75">
              <a [href]="data['iri']" target="_blank" style="color: #0056b3;">{{data['iri']}}</a>
            </dd>
          </div>
        }
        <!-- summary -->
        @if (data.hasOwnProperty('summary') && data.summary) {
          <div fxLayout="row" fxLayout.lt-md="column">
            <dt fxFlex="25">Summary:</dt>
            <dd fxFlex="75">{{data['summary']}}</dd>
          </div>
        }
        <!-- synonyms -->
        @if (data.hasOwnProperty('synonyms') && data['synonyms'] && data['synonyms'].length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Synonyms:</dt>
            <dd fxFlex="75">
              @for (syn of data['synonyms']; track syn) {
                <div style="padding-bottom: 5px;">
                  {{syn}}
                </div>
              }
            </dd>
          </div>
        }
        <!-- related_synonyms -->
        @if (data.hasOwnProperty('related_synonyms') && data['related_synonyms'] && data['related_synonyms'].length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Related Synonyms:</dt>
            <dd fxFlex="75">
              @for (rel_syn of data['related_synonyms']; track rel_syn) {
                <div style="padding-bottom: 5px;">
                  {{rel_syn}}
                </div>
              }
            </dd>
          </div>
        }
        <!-- alternative_id -->
        @if (data.hasOwnProperty('alternative_id') && data['alternative_id'] && data['alternative_id'].length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Alternative IDs:</dt>
            <dd fxFlex="75">
              @for (alt_id of data['alternative_id']; track alt_id) {
                <div style="padding-bottom: 5px;">
                  {{alt_id}}
                </div>
              }
            </dd>
          </div>
        }
        <!-- database_cross_reference -->
        @if (data.hasOwnProperty('database_cross_reference') && data['database_cross_reference'] && data['database_cross_reference'].length) {
          <div fxLayout="row" fxLayout.lt-md="column"
          >
            <dt fxFlex="25">Database Cross References:</dt>
            <dd fxFlex="75">
              @for (ref of data['database_cross_reference']; track ref) {
                <div style="padding-bottom: 5px;">
                  {{ref}}
                </div>
              }
            </dd>
          </div>
        }
      </dl>
    </div>
  }
</div>
